/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import { Route, Switch } from 'react-router-dom'
import ProtectedRoute from 'generic/router/ProtectedRoute'

/*import AudioVideoPage from 'components/pages/AudioVideoPage'*/
/*import VideoPhonePage from 'components/pages/VideoPhonePage'*/
import LoginPage from 'components/pages/LoginPage'
import DashboardPage from 'components/pages/DashboardPage'
import PrestationFormPage from 'components/pages/PrestationFormPage'
import HistoryPage from 'components/pages/HistoryPage'
import ProfilePage from 'components/pages/ProfilePage'
import AdministrationPage from 'components/pages/AdministrationPage'
import PrestationModification from 'components/applicant/PrestationModification'
import PrestationEvaluation from 'components/applicant/prestation/evaluation/PrestationEvaluation'
import PrestationProposal from 'components/applicant/PrestationProposal'
import PrestationValidation from 'components/applicant/PrestationValidation'
import PrestationInvitation from 'components/interpreter/PrestationInvitation'
import Chatbot from 'components/pages/Chatbot'

export default ({ childProps }) => (
  <Switch>
    <Route
      path="/"
      exact
      component={LoginPage}
      props={childProps}
    />
    <Route
      path="/login/"
      exact
      component={LoginPage}
      props={childProps}
    />

{/*    <Route
      path="/audio/video/"
      exact
      component={AudioVideoPage}
      props={childProps}
    />*/}

    <ProtectedRoute
      path="/dashboard/"
      exact
      component={DashboardPage}
      props={childProps}
    />
    <ProtectedRoute
      path="/history/"
      exact
      component={HistoryPage}
      props={childProps}
    />
    <ProtectedRoute
      path="/profile/"
      exact
      component={ProfilePage}
      props={childProps}
    />
    <ProtectedRoute
      path="/file/import/"
      exact
      component={AdministrationPage}
      props={childProps}
    />
    <ProtectedRoute
      path="/file/payment/"
      exact
      component={AdministrationPage}
      props={childProps}
    />
    <ProtectedRoute
      path="/applicant/list/"
      exact
      component={AdministrationPage}
      props={childProps}
    />
{/*    <ProtectedRoute
      path="/prestation/phone/"
      exact
      component={VideoPhonePage}
      props={childProps}
    />*/}
    <ProtectedRoute
      path="/prestation/:uid?/"
      exact
      component={PrestationFormPage}
      props={childProps}
    />
    <Route
      path="/prestation/modification/:token/"
      exact
      component={PrestationModification}
      props={childProps}
    />
    <Route
      path="/prestation/evaluation/:uid/:token/"
      exact
      component={PrestationEvaluation}
      props={childProps}
    />  
    <Route
      path="/prestation/proposal/:token/"
      exact
      component={PrestationProposal}
      props={childProps}
    />
    <Route
      path="/prestation/validation/distance/:token/"
      exact
      component={PrestationValidation}
      props={childProps}
    />
    <Route
      path="/prestation/invitation/:token/"
      exact
      component={PrestationInvitation}
      props={childProps}
    />    
    <Route
      path="/chat/"
      exact
      component={Chatbot}
      props={childProps}
    />    
  </Switch>
)



// WEBPACK FOOTER //
// ./src/routes.js